<section class="export-history">
    <h3 class="section-heading">Export History</h3>
    @if (exportHistory.length === 0) {
        <p class="empty-message">No exports for this transaction.</p>
    } @else {
        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="table-header">User Name</th>
                        <th class="table-header">Time Stamp</th>
                    </tr>
                </thead>
                <tbody>
                    @for (entry of sortedExportHistory; track entry.timeStamp) {
                        <tr class="table-row">
                            <td class="table-cell">{{ entry.userName }}</td>
                            <td class="table-cell">{{ entry.timeStamp | date:'MM/dd/yyyy hh:mm:ss a' }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</section>
